
import { ElButton, ElMessage } from 'element-plus'
import { defineComponent, onMounted, reactive, ref, toRefs, computed } from 'vue'
import { useRoute } from 'vue-router'
import vuex from '@/store'
import api from '@/services'
import ClipboardJS from 'clipboard'
import { $t as lang } from '@/Tool'

export default defineComponent({
  components: {
    ElButton,
  },
  setup() {
    const data = reactive({
      videoStatus: 'pause',
      showShare: false,
      userInfo: {
        mobile: '',
      },
      currentVideo: {
        id: 0,
        video: '',
        url: '',
        title: '',
      },
      videoData: [
        {
          id: 1,
          url: require('./images/out-pic3.png'),
          video: require('./images/out3.mp4'),
          title: lang('kol.tit.videoData[1]'),
        },
        {
          id: 2,
          url: require('./images/out-pic.png'),
          video: require('./images/out.mp4'),
          title: lang('kol.tit.videoData[2]'),
        },
        {
          id: 3,
          url: require('./images/out-pic2.png'),
          video: require('./images/out2.mp4'),
          title: lang('kol.tit.videoData[3]'),
        },
      ],
    })

    onMounted(() => {
      data.currentVideo = data.videoData[0]
      getUser()
    })

    const route = useRoute()

    //根据token获取userinfo
    async function queryUserInfo() {
      try {
        const res: any = await api.Scrm_sys_api.srcmLogin.getUserInfo({
          error: false,
          success: false,
          data: {},
        })
        return res
      } catch (e) {
        return e
      }
    }

    function apply() {
      const { token, invitePhone } = route.query
      if (token) {
        window.open(`${location.origin}/vshow/#/partner?token=${token}`)
      } else {
        api.ConfigServer.checkWhiteList({
          dictName: '小视频',
          childDictNameList: ['web-config'],
        }).then((res) => {
          if (res.success) {
            const webConfig = JSON.parse(
              res.data.childOption.find((item: any) => 'web-config' === item.optionName)
                ?.optionValue,
            )
            const partnerUrl = encodeURIComponent(
              `${webConfig.partnerUrl}?invitePhone=${invitePhone ? invitePhone : ''}&token=`,
            )
            window.open(`${webConfig.owsLogin}?redirect=${partnerUrl}`)
          }
        })
      }
    }

    function share() {
      ClipboardJS.copy(`${window.location.href.split('?')[0]}?invitePhone=${data.userInfo?.mobile}`)
      ElMessage({
        message: lang('kol.copyLink.success'),
        type: 'success',
      })
    }

    async function getUser() {
      const token = route.query.token
      if (token) {
        vuex.commit('set_data', {
          user: { token: token },
        })
        const userInfoRes = await queryUserInfo()
        if (userInfoRes && userInfoRes.success) {
          // 获取企业认证信息
          try {
            const entEditionInfo = await api.Scrm_sys_api.srcmLogin.queryEntEditionInfoByCorpId({
              error: false,
              success: false,
            })
            if (entEditionInfo && entEditionInfo.success) {
              // 将企业认证信息添加到用户信息中
              userInfoRes.data.auditStatus = entEditionInfo.data.auditStatus
              userInfoRes.data.businessLicenseUrl = entEditionInfo.data.businessLicenseUrl
              userInfoRes.data.authorLetterUrl = entEditionInfo.data.authorLetterUrl
              userInfoRes.data.corpName = entEditionInfo.data.name
            }
          } catch (e) {
            console.error('获取企业认证信息失败:', e)
          }
        }
        data.userInfo = userInfoRes.data
        // 代理商身份显示"分享按钮" corpType
        // data.showShare = userInfoRes.success && 3 === userInfoRes.data.type
        data.showShare = userInfoRes.success && 3 === userInfoRes.data.corpType
      }
    }

    const playOrPauseHandle = () => {
      const videoPlayer: any = document.getElementById('videoPlayer')
      if (data.videoStatus === 'pause') {
        data.videoStatus = 'playing'
        videoPlayer?.play()
      } else {
        data.videoStatus = 'pause'
        videoPlayer?.pause()
      }
    }

    const selectHandle = (item: any) => {
      data.currentVideo = item
      const videoPlayer: any = document.getElementById('videoPlayer')
      videoPlayer?.play()
      videoPlayer.muted = false
      data.videoStatus = 'playing'
    }

    return {
      ...toRefs(data),
      playOrPauseHandle,
      selectHandle,
      apply,
      share,
      lang,
    }
  },
})
